import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { isNullOrUndef, isOfType, isTruthy } from "../../../../common";
import { StoreSelectorsService } from "../../../../services";
import { BlockBaseComponent } from "../../scene-blocks/block-base/block-base.component";
import { IAnimationEngine } from "../../../../interfaces";
import { actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { DialogPresetAnimationComponent } from './../../../../components/dialog-preset-animation/dialog-preset-animation.component';
import { isNumber } from "lodash";
import * as _ from "lodash";

@Component({
    selector: "app-block-animation-details",
    templateUrl: "./block-animation-details.component.html",
    styleUrls: ["./block-animation-details.component.scss"],
    standalone: false
})

export class BlockAnimationDetailsComponent extends BlockBaseComponent {
    @Input() mode;

    animationStorePathRoot = "Data[0].Animation";
    propsGroup: FormGroup;
    defaultProps;
    booleanFields = ['ignoreInOut'];
    millisecondsFields = ['delay', 'duration'];
    dialogPresetRef;

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        public fb: FormBuilder
    ) {
        super(storeSelector);
    }

    override onInit() {
        this.initForm();
    }

    override componentInit() {
        this.setPropsOfForm();
        super.componentInit();
    }

    override componentStoreUpdates() {
        if (this.sceneItemSwitched) {
            this.setPropsOfForm();
        }
        super.componentStoreUpdates();
    }

    initForm() {
        switch (this.mode) {
            case "In":
            case "Out": {
                this.propsGroup = this.fb.group({
                    duration: [0],
                    delay: [0],
                    fadeFrq: ['1'],
                    moveFrq: ['1'],
                    moveIntense: ['1.5'],
                    moveDir: ['fixed'],
                    moveAngle: [0],
                    scaleFrq: ['1'],
                    rotateFrq: ['1'],
                    rotateType: ['fixed'],
                    rotations: [3],
                    blurFrq: ['0'],
                    blurValue: [10],
                    textTypingFrq: ['0'],
                });
                break;
            }
            case "Play": {
                this.propsGroup = this.fb.group({
                    duration: [3],
                    frequency: [1],
                    rotateFrq: ['0.5'],
                    rotateValue: ['50'],
                    fadeFrq: ['0.5'],
                    scaleFrq: ['0.5'],
                    scaleValue: ['2']
                });
                break;
            }
            case "Touch": {
                this.propsGroup = this.fb.group({
                    duration: [0.4],
                    scaleValue: [1.5],
                    outAlpha: [1.0],
                });
                break;
            }
            default:
                break;
        }
        this.defaultProps = this.propsGroup.value;
    }

    setPropsOfForm() {
        this.resetForm();
        if (!this.sceneItem) return;

        Object.keys(this.propsGroup.controls).forEach((key) => {
            const path = `${this.animationStorePathRoot}[0].${this.mode}[0].$.${key}`;
            let val = _.get(this.sceneItem, path);
            if (!isNullOrUndef(val)) {
                if (isNumber(Number(val)) && this.millisecondsFields.includes(key)) {
                    val = val / 1000;
                }
                if (this.booleanFields.includes(key)) {
                    val = isTruthy(val);
                } else if (isOfType(val) === 'NUMBER') {
                    val = Number(val);
                }
                this.propsGroup.controls[key].setValue(val, {emitEvent: false});
            }
        });
        this.updateFormStatus();
    }

    resetForm() {
        this.propsGroup.reset(this.defaultProps, {emitEvent: false});
    }

    onChangeProps(key, value = null) {
        if (isNullOrUndef(value)) {
            if (!this.propsGroup.controls[key]) {
                return;
            }
            value = this.propsGroup.controls[key].value;
        }
        if (key === 'duration' && value <= 0) {
            value = 1;
        }
        if (isNumber(value) && this.millisecondsFields.includes(key)) {
            value = value * 1000;
        }
        if (this.booleanFields.includes(key)) {
            value = isTruthy(value) ? "1" : "0";
        } else {
            value = String(value);
        }
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItemId,
            values: [{
                key,
                value,
                storePath: `${this.animationStorePathRoot}[0].${this.mode}[0].$`
            }]
        });
        this.updateFormStatus();
    }

    presetAnimation() {
        if (this.dialogPresetRef) return;
        const animation: IAnimationEngine = this.sceneItem.Data[0]?.Animation?.[0];
        this.dialogPresetRef = this.dialog.open(DialogPresetAnimationComponent, {
            width: '700px',
            data: {
                animation: _.cloneDeep(animation),
                isDialog: true,
                mode: this.mode
            }
        });

        this.dialogPresetRef.afterClosed().subscribe((animation: IAnimationEngine) => {
            this.dialogPresetRef = null;
            if (!animation) return;
            this.storeSelector.dispatch(actionUpdateSceneItem({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItemId,
                values: [{
                    key: 'Animation',
                    value: [animation],
                    storePath: `Data[0]`
                }]
            }));

            setTimeout(() => {
                this.setPropsOfForm();
            }, 300);
        });
    }

    private updateFormStatus() {
        Object.keys(this.propsGroup.controls).forEach((key) => {
            let status = true;

            if (status) {
                if (key === 'moveIntense' || key === 'moveDir') {
                    status = this.propsGroup.controls["moveFrq"].value != "0";
                }
                if (key === 'moveAngle') {
                    status = this.propsGroup.controls["moveFrq"].value != "0" && this.propsGroup.controls["moveDir"].value === "fixed";
                }
                if (key === 'blurValue') {
                    status = this.propsGroup.controls["blurFrq"].value != "0";
                }
            }
            if (status) {
                this.propsGroup.controls[key].enable();
            } else {
                this.propsGroup.controls[key].disable();
            }
        });
    }
}
